<template>
  <div class="container-fluid">
    <div
      class="
        col-12 col-md-8 col-lg-6
        my-4
        col-xl-4
        px-0 px-md-3
        mx-auto
        confirmScreenT
      "
    >
      <div class="text-center">
        <img
          src="@/assets/img/svg/ticket-checked.svg"
          width="120px"
          class="img-fluid"
        />
        <p data-v-23f776d6="" class="tTitle mt-3">
          Good News! <br />Ticket(s) Booked
        </p>
        <p data-v-23f776d6="" class="ntext my-3">
          You will soon receive an email / SMS from us with details
        </p>
        <p data-v-23f776d6="" class="eTitle"></p>

        <p class="eTitle">
          Booking ID :
          <span>{{ bookingDetails.sb_booking_code }}</span>
        </p>
      </div>
    </div>

    <div v-html="legacySystemHTML"></div>

    <div
      v-if="Object.keys(bookingDetails).length > 0"
      id="printMe2"
      class="col-12 col-md-12 col-lg-11 col-xl-9 px-0 px-md-3 mx-auto"
    >
      <div class="d-none d-lg-block">
        <div class="corner-circle-top mt-5 mx-2 ticket-shadow">
          <div class="corner-circle-bottom bg-light m-ticket-web">
            <div class="col-12">
              <div class="row">
                <div class="col-8 p-4 p-xl-5">
                  <div class="h-100">
                    <div class="row">
                      <div class="col-3 pr-0 pr-xl-3">
                        <img
                          v-lazy="bookingDetails.md_thumbnail_url"
                          class="img-fluid rounded"
                        />
                      </div>

                      <div class="col-9">
                        <div class="px-3">
                          <!-- FIRST ROW -->
                          <div class>
                            <p
                              class="
                                text-capitalize
                                font-weight-bold
                                mb-0
                                ticket-mtitle
                              "
                            >
                              {{ bookingDetails.movie_title }}
                            </p>
                            <ul class="list-inline m-tick-mInfo">
                              <li class="list-inline-item">
                                {{ bookingDetails.lang_name }} ({{
                                  bookingDetails.mf_name
                                }})
                              </li>
                              <li class="list-inline-item">
                                {{ bookingDetails.show_date | moment }}
                              </li>
                              <li class="list-inline-item">
                                {{ bookingDetails.rating }}
                              </li>
                            </ul>
                          </div>

                          <!-- SECOND ROW -->
                          <div
                            class="
                              d-flex
                              justify-content-between
                              align-items-end
                              my-3
                            "
                          >
                            <div>
                              <p class="mb-0 txt14-light-blue">
                                {{ bookingDetails.cine_name }} -
                                {{ bookingDetails.screen_name }}
                              </p>
                              <!-- <p class="mb-0">{{bookingDetails.Address}}</p> -->
                              <div class="d-flex align-items-center text-dark">
                                <div class="mr-1">
                                  <span>{{
                                    timeFormat(bookingDetails.show_time)
                                  }}</span>
                                  |
                                </div>
                                <div class="mr-1">
                                  <span class>{{
                                    (" " + bookingDetails.show_date) | moment
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            class="
                              d-flex
                              justify-content-between
                              align-items-center
                              my-3
                            "
                          >
                            <div v-if="bookingDetails.seats">
                              <p class="text-muted mb-0 tiny">
                                Seats:
                                {{
                                  bookingDetails.booking_type_id != 3
                                    ? bookingDetails.seats.length
                                    : bookingDetails.screen_total_seats
                                }}
                              </p>
                              <ul class="list-inline mt-seat-list mb-0">
                                <li class="list-inline-item mx-0">
                                  {{
                                    bookingDetails.seats
                                      .join(", ")
                                      .replace("Hall", "Auditorium")
                                  }}
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div class="m-ticket-details">
                            <div class="row mb-2">
                              <div class="col-xl-7 text-muted tiny col-md-6">
                                Ticket Price
                              </div>
                              <div
                                class="
                                  col-xl-5
                                  amt-text
                                  tiny
                                  col-md-6
                                  d-flex
                                  justify-content-end
                                "
                              >
                                {{ curr_code }}
                                {{
                                  currFormat(bookingDetails.sb_total_net_amount)
                                }}
                              </div>
                            </div>

                            <div
                              class=""
                              v-if="
                                bookingDetails.chargeTypeArray &&
                                bookingDetails.chargeTypeArray.length > 0
                              "
                            >
                              <div
                                class="row mb-2"
                                v-for="(
                                  charge, chargeIndex
                                ) in bookingDetails.chargeTypeArray"
                                :key="chargeIndex"
                              >
                                <div class="col-xl-7 text-muted tiny col-md-6">
                                  {{ charge.ct_name }}
                                </div>
                                <div
                                  class="
                                    col-xl-5
                                    amt-text
                                    tiny
                                    col-md-6
                                    d-flex
                                    justify-content-end
                                  "
                                >
                                  {{ curr_code }}
                                  {{ currFormat(charge.tax_amount) }}
                                </div>
                              </div>
                            </div>

                            <div class="row mb-2">
                              <div class="col-xl-7 text-muted tiny col-md-6">
                                Discount
                              </div>
                              <div
                                class="
                                  col-xl-5
                                  amt-text
                                  tiny
                                  col-md-6
                                  d-flex
                                  justify-content-end
                                "
                              >
                                {{ curr_code }}
                                {{ currFormat(bookingDetails.offer_price) }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- LAST ROW -->
                        <div
                          class="
                            px-3
                            mt-2
                            pt-2
                            d-md-none d-lg-block
                            mt-border-top
                          "
                        >
                          <div class="m-ticket-details">
                            <div class="row mb-2">
                              <div
                                class="
                                  col-xl-7 col-md-6
                                  ticket-mtitle
                                  font-weight-bold
                                "
                              >
                                Total
                              </div>
                              <div
                                class="
                                  col-md-6 col-xl-5
                                  ticket-mtitle
                                  font-weight-bold
                                  pr-0
                                  d-flex
                                  justify-content-end
                                "
                              >
                                {{ curr_code }}
                                {{ currFormat(totalPayableAmount) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-4 text-center p-3 p-xl-5 mt-border mt-qr-section"
                >
                  <div
                    class="
                      h-100
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                  >
                    <div class="w-100">
                      <p class="info" v-if="true">
                        Use this QR Code to Enter the Cinema
                      </p>
                      <div class="pb-2">
                        <img
                          :src="bookingDetails.qrcode"
                          :alt="'name'"
                          height="150px"
                          width="150px"
                          class="img-fluid qr-code"
                        />
                      </div>

                      <!-- PROGRESS BAR -->
                      <div class="pt-3 pb-4">
                        <div
                          class="pb-1 text-center"
                          v-if="
                            bookingDetails.booking_type_id != 3 &&
                            bookingDetails.booking_type_id
                          "
                        >
                          <p
                            class="mb-0 font-weight-bold"
                            :style="
                              bookingDetails.booking_type_id == '2'
                                ? 'color:red'
                                : ''
                            "
                          >
                            {{
                              bookingDetails.booking_type_id == 2
                                ? "Not Confirmed"
                                : "Confirmed"
                            }}
                          </p>
                        </div>
                        <div
                          v-if="
                            bookingDetails.booking_type_id != 3 &&
                            bookingDetails.booking_type_id
                          "
                        >
                          <!-- Unconfirmed -->
                          <b-progress
                            v-if="bookingDetails.booking_type_id == 2"
                            :max="parseInt(bookingDetails.screen_total_seats)"
                            class="proBar ticket-proBar red mb-0"
                          >
                            <b-progress-bar
                              :value="bookingDetails.booked_seats"
                            ></b-progress-bar>
                            <p
                              :class="
                                bookingDetails.booking_type_id == 1
                                  ? 'd-none'
                                  : ''
                              "
                              class="mb-0 reqText mx-auto pr-2"
                            >
                              {{
                                bookingDetails.booking_type_id == 2
                                  ? `Need ${
                                      bookingDetails.min_seats -
                                      bookingDetails.booked_seats
                                    } Seats to confirm`
                                  : `${
                                      bookingDetails.screen_total_seats -
                                      bookingDetails.booked_seats
                                    } seats left`
                              }}
                            </p>
                          </b-progress>
                          <!-- Confirmed -->
                          <b-progress
                            v-if="bookingDetails.booking_type_id == 1"
                            :max="parseInt(100)"
                            class="proBar ticket-proBar mb-0"
                          >
                            <b-progress-bar :value="parseInt(100)">
                              <p class="mb-0 succ-text">
                                {{
                                  bookingDetails.booking_type_id == 2
                                    ? `Need ${
                                        bookingDetails.min_seats -
                                        bookingDetails.booked_seats
                                      } seats to confirm`
                                    : `${
                                        bookingDetails.screen_total_seats -
                                        bookingDetails.booked_seats
                                      } seats left`
                                }}
                              </p>
                            </b-progress-bar>
                          </b-progress>
                        </div>
                        <div v-else-if="bookingDetails.booking_type_id == 3">
                          <b-progress
                            :max="parseInt(bookingDetails.screen_total_seats)"
                            class="proBar ticket-proBar bg-warning mb-0"
                          >
                            <b-progress-bar></b-progress-bar>
                            <p class="mb-0 reqText mx-auto pr-2">
                              Private Screening
                            </p>
                          </b-progress>
                        </div>
                        <div v-else>
                          <b-progress
                            :max="parseInt(100)"
                            class="proBar ticket-proBar bg-success mb-0"
                          >
                            <b-progress-bar></b-progress-bar>
                            <p class="mb-0 reqText mx-auto pr-2">
                              Regular Screening
                            </p>
                          </b-progress>
                        </div>
                        <input
                          type="text"
                          id="copyText"
                          :value="
                            bookingDetails.ShowType != 'Private'
                              ? 'Join me on GoGoCinema to watch ' +
                                bookingDetails.movie_title +
                                ' at ' +
                                bookingDetails.cine_name +
                                ' on ' +
                                bookingDetails.show_date +
                                ' at ' +
                                timeFormat(bookingDetails.show_time) +
                                '. Click the below link to join: \n' +
                                bookingDetails.shortLinkPwa
                              : 'I have booked a private screening on GoGoCinema! Join me to watch ' +
                                bookingDetails.movie_title +
                                ' at ' +
                                bookingDetails.cine_name +
                                ' on ' +
                                bookingDetails.show_date +
                                ' at ' +
                                timeFormat(bookingDetails.show_time) +
                                '.'
                          "
                          style="opacity: 0; height: 1px"
                        />
                        <div
                          v-if="
                            bookingDetails.ShowStatusMsg == 'UNCONFIRMED' ||
                            bookingDetails.ShowStatusMsg == 'CONFIRMED'
                          "
                        >
                          <div
                            id="tooltip-button"
                            class="btn-share"
                            @click="copyTextShare()"
                          >
                            <p style="cursor: pointer">Share</p>
                          </div>
                        </div>
                        <b-tooltip
                          :show="bookingDetails.show"
                          :disabled="true"
                          target="tooltip-button"
                          placement="bottom"
                          variant="outline-success"
                          custom-class="tool-tip-cop"
                        >
                          <strong>Copied</strong>
                        </b-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-11 mx-auto mt-3">
          <ul class="list-inline">
            <li class="list-inline-item mr-md-3">
              <p class="mb-1 text-muted">Booking Date &amp; Time:</p>
              <span>{{ bookingDetails.transaction_date_time | datetime }}</span>
              <!-- <span class>{{bookingDetails.ShowTime}} |</span>
              <span class>{{" " + bookingDetails.ShowDate | moment}}</span>-->
            </li>
            <li class="list-inline-item mr-md-3">
              <p class="mb-1 text-muted">Payment Method</p>
              <span>{{ bookingDetails.pm_payment_mode || "-" }}</span>
            </li>
            <li class="list-inline-item mr-md-3">
              <p class="mb-1 text-muted">Booking ID</p>
              <span>{{ bookingDetails.sb_booking_code }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- NEW MOBILE M-TICKET -->
    <div class="col-12 col-md-6 mx-auto px-0 d-block d-lg-none">
      <div class="new-mTicket bg-light">
        <div class="ticket-info">
          <div class="px-3 py-3">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <div>
                <img src="@/assets/img/svg/new-gogo-logo.svg" alt />
              </div>

              <div class="text-right">
                <!-- <img src="@/assets/img/svg/close-icon-new.svg" class="ml-auto" alt /> -->
                <p class="pt-2">
                  Ticket No :{{ bookingDetails.sb_booking_code }}
                </p>
              </div>
            </div>

            <div class="col-12 px-0">
              <!-- MOVIE DETAILS -->
              <div class="border-bottom pb-2">
                <p class="movie-title">{{ bookingDetails.movie_title }}</p>
                <ul class="list-inline extra-movie-info py-1">
                  <li class="list-inline-item">{{ "300 min" }}</li>
                  <li class="list-inline-item">
                    {{ bookingDetails.lang_name }}
                  </li>
                  <li class="list-inline-item">{{ bookingDetails.mf_name }}</li>
                </ul>
                <p class="dark-txt">{{ bookingDetails.cine_name }}</p>
              </div>
              <!-- TICKET INFO -->
              <div class="row pt-2">
                <div class="col-8">
                  <div class="mb-3">
                    <p class="light-txt">Date :</p>
                    <p class="dark-txt">
                      {{ bookingDetails.show_date | moment }}
                    </p>
                  </div>

                  <div class="mb-3">
                    <p class="light-txt">
                      Seats : - ({{ bookingDetails.seats.join(",") }})
                    </p>
                    <ul class="list-inline m-ticket-seats">
                      <li
                        class="list-inline-item"
                        v-for="(item, index) in bookingDetails.seats"
                        :key="index"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-4">
                  <div class="mb-3">
                    <p class="light-txt">Time :</p>
                    <p class="dark-txt">
                      {{ timeFormat(bookingDetails.show_time) }}
                    </p>
                  </div>

                  <div class="mb-3">
                    <p class="light-txt">Screen No.</p>
                    <p class="dark-txt">{{ bookingDetails.screen_name }}</p>
                  </div>
                </div>
              </div>

              <!-- TICKET PRICE -->
              <div class="row pb-2">
                <div class="col-8">
                  <p class="light-txt mb-1">Ticket Price</p>
                  <p class="light-txt mb-1" v-if="bookingDetails.total_tax">
                    TAX
                  </p>
                  <p
                    class="light-txt mb-1"
                    v-if="bookingDetails.internet_handling_fee"
                  >
                    Service Charge
                  </p>
                  <p class="light-txt mb-1" v-if="bookingDetails.offer_price">
                    Discount
                  </p>
                </div>

                <div class="col-4">
                  <p class="normal-txt">
                    {{ curr_code }}
                    {{ currFormat(bookingDetails.sb_total_net_amount) }}
                  </p>
                  <p class="normal-txt" v-if="bookingDetails.total_tax">
                    {{ curr_code }}
                    {{
                      currFormat(
                        bookingDetails.sb_total_amount -
                          bookingDetails.sb_total_net_amount
                      )
                    }}
                  </p>
                  <p
                    class="normal-txt"
                    v-if="bookingDetails.internet_handling_fee"
                  >
                    {{ curr_code }}
                    {{ currFormat(bookingDetails.internet_handling_fee) }}
                  </p>
                  <p class="normal-txt" v-if="bookingDetails.offer_price">
                    {{ curr_code }} {{ currFormat(bookingDetails.offer_price) }}
                  </p>
                </div>
              </div>

              <!-- TICKET PRICE TOTAL -->
              <div class="row border-top pt-2">
                <div class="col-8">
                  <p class="light-txt">Total</p>
                </div>

                <div class="col-4">
                  <p class="dark-txt">
                    {{ curr_code }} {{ currFormat(totalPayableAmount) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="qr-section qr-section pt-3 pb-5">
          <!-- PROGRESS BAR -->
          <div
            class="pt-3 pb-0 px-3 px-md-4"
            :style="
              bookingDetails.ShowType == 'Private' ? 'margin: 2px 54px;' : ''
            "
          >
            <div
              class="pb-1 text-center"
              v-if="bookingDetails.ShowType != 'Private'"
            >
              <p
                v-if="bookingDetails.ConfirmedStatus == false"
                class="mb-0 font-weight-bold"
                :style="bookingDetails.ShowStatus == '2' ? 'color:red' : ''"
              >
                {{ bookingDetails.ShowStatusMsg }}
              </p>
              <p
                v-if="bookingDetails.ConfirmedStatus"
                class="mb-0 font-weight-bold"
                :style="bookingDetails.ShowStatus == '3' ? 'color:red' : ''"
              >
                {{ bookingDetails.ShowStatusMsg }}
              </p>
            </div>
            <div v-if="bookingDetails.ShowType != 'Private'">
              <!-- UNCONFIRMED -->
              <div
                class="new-progress-bar unconfirmed"
                v-if="
                  bookingDetails.ConfirmedStatus == false &&
                  bookingDetails.ShowStatus == '0'
                "
              >
                <b-progress
                  style="width: 10%"
                  :max="parseInt(bookingDetails.TotalSeat)"
                >
                  <b-progress-bar></b-progress-bar>
                </b-progress>
                <p class="proBar-text" v-html="bookingDetails.ExpiryMsg"></p>
              </div>

              <!-- CONFIRMED -->
              <div
                class="new-progress-bar confirmed"
                v-if="
                  bookingDetails.ConfirmedStatus &&
                  bookingDetails.ShowStatus == '1'
                "
              >
                <b-progress
                  style="width: 100%"
                  :max="parseInt(bookingDetails.TotalSeat)"
                >
                  <b-progress-bar></b-progress-bar>
                </b-progress>
                <p class="proBar-text" v-html="bookingDetails.ExpiryMsg"></p>
              </div>
            </div>
            <div class="new-progress-bar bg-warning" v-else>
              <b-progress
                style="width: 0%"
                :max="parseInt(bookingDetails.TotalSeat)"
              >
                <b-progress-bar></b-progress-bar>
              </b-progress>
              <p class="proBar-text">Private Screening</p>
            </div>
          </div>
          <div class="align-self-center text-center">
            <p class="qr-note" v-if="bookingDetails.ShowStatus == '1'">
              Use this QR Code to Enter the Cinema
            </p>
            <div class="py-3">
              <img
                :src="bookingDetails.qrcode"
                alt="'name'"
                height="150px"
                width="150px"
                class="img-fluid qr-code"
              />
              <!-- <div class="tag">unconfirmed</div> -->
            </div>
            <div
              v-if="
                bookingDetails.ShowStatusMsg == 'UNCONFIRMED' ||
                bookingDetails.ShowStatusMsg == 'CONFIRMED'
              "
            >
              <navigator-share
                v-bind:on-error="onError"
                v-bind:on-success="onSuccess"
                :text="
                  bookingDetails.ShowType != 'Private'
                    ? 'Join me on GoGoCinema to watch ' +
                      bookingDetails.Title +
                      ' at ' +
                      bookingDetails.CinemaName +
                      ' on ' +
                      bookingDetails.ShowDate +
                      ' at ' +
                      bookingDetails.ShowTime +
                      '. Click the below link to join: \n' +
                      bookingDetails.shortLinkPwa
                    : 'I have booked a private screening on GoGoCinema! Join me to watch ' +
                      bookingDetails.Title +
                      ' at ' +
                      bookingDetails.CinemaName +
                      ' on ' +
                      bookingDetails.ShowDate +
                      ' at ' +
                      bookingDetails.ShowTime +
                      '.'
                "
                class="btn-share"
              ></navigator-share>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
    <div class="col-12 col-md-10 col-lg-6 mx-auto my-5 d-none d-lg-block">
      <div class="row">
        <div class="col-6 col-lg-5 col-xl-4 mx-auto text-center">
          <router-link
            class="mt-3 btn btn-danger text-light"
            :to="{
              name: 'Home',
            }"
            >Home</router-link
          >
        </div>
      </div>
    </div>
    <div class="invite-pop">
      <b-modal
        ref="invitemodal"
        title="Invite Friend"
        class="welcome-b header"
        id="invite"
        hide-footer
      >
        <div class="p-4">
          <div class="invite-section">
            <p class="invite-txt mb-3">Send ticket to a friend</p>
            <form data-vv-scope="inviteFriend" class="d-md-flex w-100">
              <input
                v-model="friendemail"
                v-validate="'required|email'"
                type="text"
                name="email"
                class="form-control py-4 w-100"
                placeholder="Enter Your Friend's Email Address"
              />
            </form>
            <div
              v-show="errors.has('inviteFriend.email')"
              class="py-1 text-danger font-weight-bold small"
            >
              {{ errors.first("inviteFriend.email") }}
            </div>
          </div>
          <div class="text-danger mt-3 small font-weight-bold">
            {{ errorMessage }}
          </div>
          <div class="mt-3">
            <input
              @click.stop="validateBeforeSubmit('inviteFriend')"
              type="submit"
              class="gogo-btn btn btn-danger"
              value="Send"
            />
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
import { makeRequest } from "@/helper/internet.js";
import { TokenService } from "@/services/storage.service";
import NavigatorShare from "vue-navigator-share";
import moment from "moment";
import MainServices from "@/services/mainService.js";
import AuthServices from "@/services/AuthServices.js";
import PromotionServices from "@/services/PromotionServices.js";
import rtsServices from "@/services/rtsServices";

export default {
  name: "confirmScreen",
  directives: {},

  components: {
    Slick,
    DatePick,
    NavigatorShare,
  },

  data() {
    return {
      legacySystemHTML: "",
      bookingDetails: {},
      bookingId: "",
      paymentId: "",
      friendemail: "",
      errorMessage: "",
      reserveID: "",
      counter: 0,
      rts_reserve_id: null,
      category_id: null,
    };
  },
  filters: {
    moment(date) {
      return moment(date).format("DD-MMM-YYYY");
    },
    datetime(date) {
      return moment(date).format("DD-MMM-YYYY HH:mm");
    },
  },
  computed: {
    totalPayableAmount() {
      let total =
        this.bookingDetails.sb_total_amount -
        this.bookingDetails.offer_price -
        this.bookingDetails.TaxOffer;
      return total;
    },
    curr_code() {
      return this.$store.getters.getCurrCode;
    },
    userInfo() {
      if (localStorage.getItem("user")) {
        let user = JSON.parse(localStorage.getItem("user"));
        this.userLoggedIn = true;
        return user;
      } else {
        return false;
      }
    },
  },
  beforeMount() {
    this.hideLoading();
    this.rts_reserve_id = this.$route.params.rts_reserve_id;
    this.category_id = this.$route.params.category_id || 1;
    this.fetchBookingDetails();
  },
  methods: {
    copyTextShare() {
      var copyText = document.getElementById("copyText");
      copyText.select();
      document.execCommand("copy");
      var self = this;
      this.bookingDetails["Title"] = this.bookingDetails["Title"] + "  ";
      this.bookingDetails.show = true;
      setTimeout(function () {
        self.bookingDetails.show = false;
        self.bookingDetails["Title"] = self.bookingDetails["Title"] + " ";
      }, 2000);
    },
    onError(err) {
      alert(err);
      console.log(err);
    },
    onSuccess(err) {
      console.log(err);
    },
    async fetchBookingDetails() {
      try {
        this.showLoading();
        const payload = {
          reserve_id: this.rts_reserve_id,
        };
        const response = await rtsServices.getBookingDetails(payload);
        const { data } = response;
        if (data.status) {
          this.bookingDetails = data.Records[0];
          this.bookingDetails["show"] = false;
        }
      } catch (err) {
        console.log("Error:", err);
      }
      this.hideLoading();
    },
    validateBeforeSubmit(scope) {
      if (scope == "inviteFriend") {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            // this.showLoading();
            let token = TokenService.getToken();
            let payload = {
              FriendEmail: this.friendemail,
              BookingID: this.bookingId,
            };
            makeRequest("/Booking/ResendTickets", "POST", token, payload)
              .then((response) => {
                const { error, res } = response;
                if (!error && res.data.Status) {
                  this.errorMessage =
                    "Ticekt has been sent to your friend's email address";
                } else {
                  this.errorMessage = res.data.Message;
                }
                setTimeout(() => {
                  this.$refs.invitemodal.hide();
                }, 3000);
              })
              .catch((error) => {
                this.errorMessage = "Something went wrong!";
                console.log("Error", error);
                this.hideLoading();
              });
            return;
          }
        });
      }
    },
  },
};
</script>

<style scoped>
body {
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background: url("../../../assets/img/svg/bg.svg");
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ExternalConfirmScreen/confirmScreenRts.vue